import React, { useState,useEffect } from "react";
import { toast } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import ListCourseSkeleton from "components/skeleton/ListCourseSkeleton";
import LectureNoteFound from "components/Not-Found/LectureNotFound";
import { charLimit, countArray } from "config/utils";
import { lectureTimeTracking, onDemandLectureSection,OnDemandlectureListView } from "services/lecture";
import SuperTag from "components/SuperTag/SuperTag";
import { AiFillCheckCircle } from "react-icons/ai";
import { LectureShubhraImg } from "assets/images";
import { AiFillClockCircle } from "react-icons/ai";
import { Lock_lecture, VideoPlayIconImg, ViewdetailsImg } from "assets/icons";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import CommonModal from "components/modal-box/CommonModal";
import { FaExclamationCircle } from "react-icons/fa";
import { errorResponse, failResponse, normalEncryptData } from "config/config";
import { useCourse } from "context/context";
import { getUserIp } from "services/third-party";
import useButtonLoader from "hooks/useButtonLoader";
import { BsFillInfoCircleFill } from "react-icons/bs";

let GLOBAL_LOCAL_LIMIT = 3;
let MAIN_PERCENTAGE = 100;

const OnDemandSectionA = ({
  sectionId,
  sectionName,
  sectionDescription,
  courseId,
}) => {
  
  const [loading, setLoading] = useState(false);
  const [listLectures, setListLectures] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [descriptionModal, setDescriptionModal] = useState(false);
  const [guideModal, setGuideModal] = useState(false);
  const { course } = useCourse();
  const [buttonRef, setSubmitLoading] = useButtonLoader("Yes");
  const [totalLectures, setTotalLectures] = useState(0);


  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  const updateMedia = () => {
    setIsMobile(window.innerWidth <= 600);
  };

  useEffect(() => {
    window.addEventListener('resize', updateMedia);
    return () => window.removeEventListener('resize', updateMedia);
  }, []);

  const getLiStyle = () => {
    return isMobile ? { paddingLeft: "0px" } : { paddingLeft: "230px" };
  };

  const getSectionStyle = () => {
    return isMobile ? { marginBottom: "10px" } : {};
  };


  const [mainIndex, setMainIndex] = useState(0);
  const [playingIndex, setPlayingIndex] = useState(0);
  const navigate = useNavigate();

  // next handler
  const nextHandler = async () => {
    let mainListing = listLectures.map((data, i) => data);
    let prevIndex = mainIndex - GLOBAL_LOCAL_LIMIT + 1;

    // if prev index is exist
    if (prevIndex > GLOBAL_LOCAL_LIMIT) {
      mainListing[prevIndex].locked = true;
    }
    mainListing[mainIndex + 1].locked = false;
    setListLectures(mainListing || []);
    try {
      setSubmitLoading(true);
      // add entry in db to lock previous lecture
      const { data: ip } = await getUserIp();
      const trackingRes = await lectureTimeTracking({
        Platform: "web",
        courseId: course.courseId,
        IPAddress: ip.ip,
        playTime: 0,
        TotalCoverdTime: 0,
        TotalPlayedTime: 0,
        lastPlay: 0,
        lectureId: mainListing[mainIndex + 1]?.LectureID,
        sectionId,
      });
      if (trackingRes?.code === 200) {
        setSubmitLoading(false);
        setConfirmModal(false);

        if (mainListing[mainIndex + 2]?.LectureID) {
          navigate(
            `/dashboard/demand-lecture/detail/${sectionId}/${normalEncryptData(
              `${mainListing[mainIndex + 1]?.LectureID},${
                mainListing[mainIndex + 2]?.LectureID
              }`,
              "route"
            )}`,
            {
              state: { auth: true },
            }
          );
        } else {
          navigate(
            `/dashboard/demand-lecture/detail/${sectionId}/${normalEncryptData(
              `${mainListing[mainIndex + 1]?.LectureID}`,
              "route"
            )}`,
            {
              state: { auth: true },
            }
          );
        }
      } else {
        setSubmitLoading(false);
        failResponse(trackingRes);
      }
    } catch (err) {
      setSubmitLoading(false);
      errorResponse(err);
    }
  };

  //  video selection handlers
  const videoSelectionHandler = (lecture, locked, ind) => {
    if (!course.coursePlatformEnabled) {
      toast.error(
        "Lectures of Tablet platform or Mobile platform cannot be seen on website "
      );
      return;
    }

    setPlayingIndex(ind + 1);

    if (mainIndex < 0) {
      toast.error("This lecture is locked");
      return;
    }

    if (mainIndex + 1 === ind) {
      setConfirmModal(true);
    } else if (locked) {
      toast.error("This video is locked");
    } else {
      if (listLectures[ind + 1]?.LectureID) {
        navigate(
          `/dashboard/demand-lecture/detail/${sectionId}/${normalEncryptData(
            `${lecture?.LectureID},${listLectures[ind + 1]?.LectureID}`,
            "route"
          )}`,
          {
            state: { auth: true },
          }
        );
      } else {
        navigate(
          `/dashboard/demand-lecture/detail/${sectionId}/${normalEncryptData(
            `${lecture?.LectureID}`,
            "route"
          )}`,
          {
            state: { auth: true },
          }
        );
      }
    }
  };

  const lockedFunction = (data, findInd, ind) => {
    let locData = { locked: false };
    // unlock if is playing 1
    if (findInd < ind) {
      Object.assign(locData, {
        locked: true,
      });
    }

    // locked that lecture before is playing
    if (findInd - GLOBAL_LOCAL_LIMIT >= ind) {
      Object.assign(locData, {
        locked: true,
      });
    }

    // locked that lecture if playing percentage is grater then or equal to main percentage
    if (data.playVideoPercantage >= MAIN_PERCENTAGE) {
      Object.assign(locData, {
        locked: true,
      });
    }

    return locData;
  };

  // get course lectures
    const getLecturesList = async () => {
      try {
        setLoading(true);

        const res = await OnDemandlectureListView({
          section_id: sectionId,
          course_id: courseId,
        });

        if (res.code === 200) {
          const {rows } = res.data.lectures;
          
          let findIndex = rows.findIndex((data) => data.isPlaying);
          setMainIndex(findIndex);
          const mainListing = rows.map((data, i) => {
            return {
              ...data,
              ...lockedFunction(data, findIndex, i),
            };
          });
          setTotalLectures(res.data.totallectures);
          
          setListLectures(mainListing || []);
          setLoading(false);
        } else {
          failResponse(res);
          setLoading(false);
        }
      } catch (err) {
        errorResponse(err);
        setLoading(false);
      }
    };

  // ----------------------- getting courses detail data -------------------------//
  React.useLayoutEffect(() => {
    sectionId && getLecturesList();
    // eslint-disable-next-line
  }, [sectionId]);


   

  return (
    <>
      <div className="daily_lecture">
        <div className="meeting_content">
          <div className="syllabus_paper">
            <ul style={{marginTop:"-35px"}}>
              <li style={getSectionStyle()}>
                <h6>{sectionName}</h6>
                <h6 style={isMobile ? { marginLeft: "15px" } : {}}>(Total Lectures: {totalLectures})</h6>
              </li>
              
              <li style={getLiStyle()}>
                <h6
                  onClick={() => {
                    setDescriptionModal(true);
                  }}
                >
                  View Syllabus
                </h6>
                 
                <span
                  className="info-icon"
                  onClick={() => {
                    setGuideModal(true);
                  }}
                >
                  
                  <BsFillInfoCircleFill />
                </span>
              </li>
            </ul>
          </div>

          <div className="onDemandLectures"style={{marginTop:"-25px"}}>
            {/* ************ Loading Component *********** */}
            {loading && (
              <div className="d-flex justify-content-between  w-100">
                {countArray(4).map((data) => {
                  return (
                    <div className="onDemandCard_wrap p-0 mx-2" key={data}>
                      <div className="onDemandCard p-0">
                        <ListCourseSkeleton height={320} />
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {/* iterate lectures */}

            {!loading && listLectures.length > 0 && (

              <>
              
                
                {listLectures.map(
                  (
                    {
                      LectureID,

                      LectureTitle,
                      AllocatedTime,
                      consumedTime,
                      remainingTime,
                      Duration,
                      vdocipherDetail,
                      lecturetime,
                      lectureStatus,
                      isPlaying,
                      playVideoPercantage,
                      locked,
                      file,
                    },
                    i
                  ) => {
                    return (
                      <div className="onDemandCard_wrap"
                       key={LectureID}
                       style={{ width: "10", marginBottom: "" }}
                       >
                        <div className="onDemandCard">
                          <div className="image_wrap">
                            <a
                              onClick={() =>
                                videoSelectionHandler(
                                  {
                                    file,
                                    Duration,
                                    AllocatedTime,
                                    LectureTitle,
                                    LectureID,
                                  },
                                  locked,
                                  i
                                )
                              }
                            >
                              <img
                                src={
                                  vdocipherDetail?.poster || LectureShubhraImg
                                }
                                alt={LectureTitle}
                              />
                              <img
                                src={locked ? Lock_lecture : VideoPlayIconImg}
                                alt=""
                                className="iconImg"
                              />
                              <span className="serial_number">{i + 1}</span>
                            </a>
                          </div>
                          <div className="content">
                            <span className="red">Lec {i + 1}</span>
                            <h6>{charLimit(LectureTitle, 40)}</h6>
                            <ul>
                              <li className="light_blue">
                                <AiFillClockCircle /> {Duration}&nbsp;min
                              </li>
                              <li></li>

                              {lectureStatus !== 0 ? (
                                <li
                                  className={`${
                                    lectureStatus === 1 ? "green" : ""
                                  }`}
                                >
                                  <AiFillCheckCircle />
                                </li>
                              ) : (
                                <li></li>
                              )}
                            </ul>
                          </div>
                          <div className="View_details">
                            <span className="view_text">
                              <img src={ViewdetailsImg} alt="" loading="lazy" />
                              <span className="text">View details</span>
                            </span>
                            <ul>
                              <li>
                                <span>Lecture duration</span>
                                <span className="text" style={{fontSize:"11px",fontWeight:"600"}}>
                                  <AiFillClockCircle /> {Duration} min
                                </span>
                              </li>
                              <li>
                                <span>Allocated time</span>
                                <span className="text" style={{fontSize:"11px",fontWeight:"600"}}>
                                  <AiFillClockCircle /> {AllocatedTime} min
                                </span>
                              </li>
                              <li>
                                <span>Consumed time</span>
                                <span className="text" style={{fontSize:"11px",fontWeight:"600"}}>
                                  <AiFillClockCircle /> {consumedTime} min
                                </span>
                              </li>
                              <li>
                                <span>Remaining time</span>
                                <span className="text" style={{fontSize:"11px",fontWeight:"600"}}>
                                  <AiFillClockCircle /> {remainingTime} min
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
                
              </>
            )}

            {/* Not Found */}
            {!loading && listLectures.length <= 0 && (
              <>
                <LectureNoteFound title="Lecture" />
              </>
            )}
          </div>
        </div>
      </div>

      {/* usr consent message */}
      <CommonModal
        show={confirmModal}
        handleClose={() => setConfirmModal(false)}
        size="md"
      >
        <div className="logout">
          <span className="logout_icon">
            <FaExclamationCircle />
          </span>
          <h3>Alert</h3>
          <p>
            Message "I endorse that lecture number {mainIndex + 1} is completed
            watching. I also understand that allocated time for this lecture
            will be lapsed in-case it is not consumed completely and this
            lecture will not be available to watch in the future. Do you want to
            move to lecture number {mainIndex + 2}?
          </p>

          <div className="button_wrap center">
            <button
              className="dashboard_button"
              onClick={() => setConfirmModal(false)}
            >
              No
            </button>
            <button
              className="dashboard_button green"
              onClick={() => nextHandler()}
              ref={buttonRef}
            >
              Yes
            </button>
          </div>
        </div>
      </CommonModal>

      {/* section description modal */}
      <CommonModal
        show={descriptionModal}
        handleClose={() => setDescriptionModal(false)}
        size="lg"
      >
        <div className="contain">
          <h6>{sectionName}</h6>
          <SuperTag>{sectionDescription}</SuperTag>
        </div>
      </CommonModal>

      {/* user guide modal */}
      <CommonModal
        show={guideModal}
        handleClose={() => setGuideModal(false)}
        size="lg"
      >
        <div className="contain">
          <h6>What is ‘On Demand’ Course?</h6>
          <p>
            It is a Foundation Course which gives super flexibility to the
            students when it comes to time and pace of the lectures. This
            lecture is similar as it happens in the regular classes. Som
            examples are, PSIR Optional by Shubhra Ranjan Ma’am, Sociology,
            History, Anthropology on demand courses.
          </p>
          <h6>What is maximum duration for the course?</h6>
          <p>
            The course duration is one year from the date of subscription. Thus,
            the student will have to either finish the lecture before this
            one-year duration or the course will automatically expire after one
            year from the date of subscription.
          </p>
          <h6>
            What is Lecture Duration, Allocated time, Remaining time of a
            particular lecture?
          </h6>
          <p>
            Note: all time is represented in hh:mm Lecture Duration– Actual time
            of a Lecture. Allocated Time – Time allocated to view a particular
            lecture. Normally if lecture duration is 60 minutes (01:00), then
            allocated time can be 02:00. Means 60 minutes of lecture can be seen
            for up-to 120 minutes. Remaining Time: Time remaining to view a
            particular lecture. If allocated time for a particular lecture is
            02:00 hours (120 minutes), And if lecture is seen for say 00:40
            minutes then remaining time for that particular lecture would be
            01:20 (80 minutes).
          </p>
          <h6>What should be the flow of the lectures?</h6>
          <p>
            Upon subscription, a student can select the Section of his choice.
            Upon entering the section, the student will have to start from the
            first lecture of that section. He can navigate back from the current
            lecture up to 2 previous lectures. However, he can watch previous
            lecture only if the allotted time is not finished.
          </p>
          <h6>Can I go back across sections?</h6>
          <p>No.</p>
          <h6>Does the remaining time of one lecture adds up to the next?</h6>
          <p>No.</p>

          {/* <p>
            <span className="text-danger">Note : </span>  
            On demand course is created once for that subject. Like there will 3
            on demand courses 1) PSIR, 2) History 3) Anthropology These on
            demand courses will have todays date as start date always. End date
            for the student will be calculated from the duration. Like for
            History if duration is 6 months, If student 1 purchase it on 1 Nov,
            His end date will be 1Nov +6 months = 30 May If student 2 purchase
            it on 1 Dec, His end date will be 1Dec +6 months = 30 Jun
          </p> */}
        </div>
      </CommonModal>
    </>
  );
};

export default OnDemandSectionA;
